import { nanoid } from 'nanoid';
// this char shouldn't be in alphabet of generator of id
// Used for marking Sequenced flow which is completed. Used to safe space in external storages
const _shortSeqFlowPostfix = '*';
export function generateTrackingIdentifier() {
    return nanoid(8);
}
export function addSequencedFlowPostfix(trackingId) {
    return (trackingId + _shortSeqFlowPostfix);
}
export function tryRemoveSequencedFlowPostfix(trackingId) {
    if (trackingId.endsWith(_shortSeqFlowPostfix)) {
        const trackingIdWithoutPostfix = trackingId.substring(0, trackingId.length - _shortSeqFlowPostfix.length);
        return {
            trackingIdentifier: trackingIdWithoutPostfix,
            wasRemoved: true,
        };
    }
    return {
        wasRemoved: false,
    };
}
